module.exports = __webpack_public_path__ + "static/img/indexbg3.0959fbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/indexbg3.jpg
// module id = Qasi
// module chunks = 1